import { Routes, Route } from "react-router-dom";

import ContainerTypes from "./ContainerTypes";

const index = () => {
	return (
		<Routes>
			<Route index element={<ContainerTypes />} />
		</Routes>
	);
};

export default index;
